import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StandardDropdown from '@wix/da-ds/pkg/Dropdown/Preset/StandardDropdown';
import { GallectionSortOrder } from '../../../../../types/gallection';

export interface Props {
  sorderOrder: GallectionSortOrder;
  setSortOrder: (value: GallectionSortOrder) => void;
  className?: string;
}

function SortOrderSwitcher({ sorderOrder, setSortOrder, className }: Props) {
  const { t } = useTranslation();
  const items = useMemo(
    () => [
      {
        value: GallectionSortOrder.NEWEST,
        label: t('common.sortOrder.newest'),
      },
      {
        value: GallectionSortOrder.POPULAR,
        label: t('common.sortOrder.popular'),
      },
    ],
    [t]
  );

  return (
    <StandardDropdown
      role="menu"
      className={className}
      placement="bottom-end"
      selectedValue={sorderOrder}
      onSelect={setSortOrder}
      items={items}
    />
  );
}

export default SortOrderSwitcher;
